var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#truck--6HQ3r';
                    var viewUrl = 'sprites.svg#view-truck--6HQ3r';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 31 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };